// ── 執行期設定：登入網址與 loading 圖由伺服器依環境提供，不在 build 時寫死 ──────────

/** 取得主網域登入網址；失敗或格式不對回傳 null，由呼叫端決定如何呈現（不猜網域） */
export const fetchMainLoginUrl = async (): Promise<string | null> => {
  try {
    const res = await fetch('/api/client-config');
    if (!res.ok) return null;
    const body = (await res.json()) as { mainLoginUrl?: unknown };
    return typeof body.mainLoginUrl === 'string' && body.mainLoginUrl !== '' ? body.mainLoginUrl : null;
  } catch {
    return null;
  }
};

let loadingLogoUrlPromise: Promise<string | null> | null = null;

/** 取得 loading 吉祥物圖網址；全站只打一次，失敗或未設定回傳 null（顯示替代圖形） */
export const fetchLoadingLogoUrl = (): Promise<string | null> => {
  loadingLogoUrlPromise ??= (async () => {
    try {
      const res = await fetch('/api/client-config');
      if (!res.ok) return null;
      const body = (await res.json()) as { loadingLogoUrl?: unknown };
      return typeof body.loadingLogoUrl === 'string' && body.loadingLogoUrl !== '' ? body.loadingLogoUrl : null;
    } catch {
      return null;
    }
  })();
  return loadingLogoUrlPromise;
};
